import * as React from 'react';
import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';

const Taxonomies = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-taxonomies',
      // styles
      'flex animate-in flex-col flex-wrap rounded-[10px] bg-white p-6 shadow-[0px_4px_10px_rgba(68,43,140,0.05)] fade-in xl:flex-row',
      className
    )}
    {...props}
  />
));
Taxonomies.displayName = 'Taxonomies';

const TaxonomiesColumn = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-taxonomies-column',
      // styles
      'min-w-[260px] flex-grow border-b border-solid border-neutral-lightest px-0 py-2.5 first:pl-0 last:border-b-0 last:pr-0 xl:max-w-[33.33%] xl:border-b-0 xl:border-r xl:px-10 xl:py-2.5 xl:last:border-r-0',
      className
    )}
    {...props}
  />
));
TaxonomiesColumn.displayName = 'TaxonomiesColumn';

const TaxonomiesList = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-taxonomies-list', className)}
    {...props}
  />
));
TaxonomiesList.displayName = 'TaxonomiesList';

const TaxonomiesItem = React.forwardRef(({ className, active, asChild, ...props }, ref) => {
  const Comp = asChild ? Slot : 'div';

  return (
    <Comp
      ref={ref}
      className={cn(
        'c-taxonomies-item',
        // styles
        'group mb-4 flex cursor-pointer items-center justify-between gap-2 rounded-full border border-solid border-primary-lightest bg-clip-padding px-4 py-2 text-[0.8em] text-neutral-darker transition-colors',
        active ? 'bg-primary text-white' : 'hover:bg-primary hover:text-white',
        className
      )}
      {...props}
    />
  );
});
TaxonomiesItem.displayName = 'TaxonomiesItem';

const TaxonomiesText = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-taxonomies-text',
      // styles
      'inline-block flex-grow truncate text-[13px]',
      className
    )}
    {...props}
  />
));
TaxonomiesText.displayName = 'TaxonomiesText';

const TaxonomiesButton = React.forwardRef(({ className, ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      'c-taxonomies-btn',
      // styles
      '-mt-[0.1em] shrink-0 appearance-none border-none bg-transparent p-0 text-neutral transition-colors group-hover:text-white',
      className
    )}
    {...props}
  />
));
TaxonomiesButton.displayName = 'TaxonomiesButton';

const TaxonomiesIcon = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-taxonomies-icon',
      // styles
      'mr-2.5 w-[10px] shrink-0 cursor-grab transition-all group-hover:brightness-0 group-hover:invert',
      className
    )}
    {...props}
  />
));
TaxonomiesIcon.displayName = 'TaxonomiesIcon';

export { Taxonomies, TaxonomiesColumn, TaxonomiesList, TaxonomiesItem, TaxonomiesText, TaxonomiesButton, TaxonomiesIcon };
